import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useTheme } from '@react-navigation/native';

import { useLocale } from '../i18n/LocaleContext';
import { SPACE } from '../theme/spacing';

/**
 * Правая панель широкого окна, пока чат не выбран (см. navigation/chatPane). Стоит в стеке
 * на месте списка чатов: «назад» из чата приводит сюда, а не к второму списку рядом с первым.
 */
export function ChatPanePlaceholder() {
  const { t } = useLocale();
  const { colors } = useTheme();
  return (
    <View style={[styles.root, { backgroundColor: colors.background }]}>
      <View style={[styles.badge, { borderColor: colors.border, backgroundColor: colors.card }]}>
        <Text style={[styles.title, { color: colors.text }]}>{t('chatPaneEmptyTitle')}</Text>
        <Text style={[styles.hint, { color: colors.text }]}>{t('chatPaneEmptyHint')}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: { flex: 1, alignItems: 'center', justifyContent: 'center', padding: SPACE.lg },
  badge: {
    maxWidth: 360,
    alignItems: 'center',
    gap: SPACE.sm,
    paddingVertical: SPACE.lg,
    paddingHorizontal: SPACE.xl,
    borderRadius: 16,
    borderWidth: StyleSheet.hairlineWidth,
  },
  title: { fontSize: 17, fontWeight: '600' },
  hint: { fontSize: 14, opacity: 0.7, textAlign: 'center' },
});
